"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantPatchViewModel = void 0;
var class_transformer_1 = require("class-transformer");
var TenantPatchViewModel = /** @class */ (function () {
    function TenantPatchViewModel() {
        this.acceptsTermsAndConditions = null;
        this.address1 = null;
        this.address2 = null;
        this.advancedAssetSharingAccess = null;
        this.advancedPortalUser = null;
        this.aliasCarrierIdAccess = null;
        this.autoAccept = null;
        this.automaticInvitationResendsDefault = null;
        this.carrierNetworkRoles = null;
        this.city = null;
        this.contactEmail = null;
        this.contactPerson = null;
        this.contactPhone = null;
        this.country = null;
        this.demo = null;
        this.dotNumber = null;
        this.genesis = null;
        this.ghCarrierId = null;
        this.integrator = null;
        this.locale = null;
        this.mcNumber = null;
        this.name = null;
        this.notificationType = null;
        this.participant = null;
        this.provider = null;
        this.purpose = null;
        this.regions = null;
        this.salesforceAccountId = null;
        this.scac = null;
        this.screeningStatus = null;
        this.showToPublic = null;
        this.ssoIdentityProviderName = null;
        this.stateProvinceRegion = null;
        this.subscriber = null;
        this.tags = null;
        this.tenantStatus = null;
        this.vatNo = null;
        this.zip = null;
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "acceptsTermsAndConditions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "address1", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "address2", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "advancedAssetSharingAccess", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "advancedPortalUser", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "aliasCarrierIdAccess", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "autoAccept", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "automaticInvitationResendsDefault", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "carrierNetworkRoles", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "city", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "contactEmail", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "contactPerson", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "contactPhone", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "country", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "demo", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "dotNumber", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "genesis", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "ghCarrierId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "integrator", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "locale", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "mcNumber", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "name", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "notificationType", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "participant", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "provider", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "purpose", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "regions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "salesforceAccountId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "scac", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "screeningStatus", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "showToPublic", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "ssoIdentityProviderName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "stateProvinceRegion", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "subscriber", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "tags", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "tenantStatus", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "vatNo", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantPatchViewModel.prototype, "zip", void 0);
    return TenantPatchViewModel;
}());
exports.TenantPatchViewModel = TenantPatchViewModel;
